'use strict';

var StrategyReadonlyAllocationAuthAvailDirective = function StrategyReadonlyAllocationAuthAvailDirective() {
  return {
    restrict: 'E',
    replace: true,
    require: '^rmStrategyReadonly',
    template: require('../templates/strategy-readonly-allocation-auth-avail.html')
  };
};
StrategyReadonlyAllocationAuthAvailDirective.$inject = [];
module.exports = StrategyReadonlyAllocationAuthAvailDirective;